import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

import Close from '@mui/icons-material/Close';
import Notifications from '@mui/icons-material/Notifications';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMarkInAppNotificationAsRead } from '~/hooks/api/useMarkInAppNotificationsAsRead';
import { useUnreadInAppNotifications } from '~/hooks/api/useUnreadInAppNotifications';
import messages from './messages';
import { Link } from '@tanstack/react-router';

export const InAppNotificationsButton = () => {
  const intl = useIntl();
  const { data: inAppNotifications } = useUnreadInAppNotifications();
  const markAsReadMutation = useMarkInAppNotificationAsRead();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  return (
    <>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        color="inherit"
        aria-label={intl.formatMessage(messages.showNotifications)}
        size="large"
      >
        <Badge
          badgeContent={`${inAppNotifications ? inAppNotifications.length : 0}`}
          color="secondary"
        >
          <Notifications />
        </Badge>
      </IconButton>
      <Popper id={id} open={open} anchorEl={anchorEl}>
        <Paper sx={{ maxHeight: 320, maxWidth: 320, overflowY: 'auto' }}>
          <List>
            {inAppNotifications?.length === 0 ? (
              <ListItem>
                <ListItemText
                  secondary={
                    <FormattedMessage {...messages.noUnreadNotifications} />
                  }
                />
              </ListItem>
            ) : null}
            {inAppNotifications?.map((inAppNotification) => (
              <ListItem
                key={inAppNotification.id}
                secondaryAction={
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage(messages.markAsRead)}
                    onClick={() => {
                      if (!inAppNotification.id) {
                        return;
                      }
                      markAsReadMutation.mutate(inAppNotification.id);
                    }}
                    size="large"
                  >
                    <Close />
                  </IconButton>
                }
                disablePadding
              >
                <ListItemButton
                  component={Link}
                  to={`${inAppNotification.url}`}
                  onClick={() => {
                    if (!inAppNotification.id) {
                      return;
                    }
                    markAsReadMutation.mutate(inAppNotification.id);
                  }}
                >
                  <ListItemText primary={inAppNotification.body} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popper>
    </>
  );
};
